import React, { useEffect, useState } from 'react'

const ShowcaseOption = ({ showcase, add, remove, isShow }) => {
    const [check, setCheck] = useState(false)

    useEffect(() => {
        if (isShow === false) {
            setCheck(false)
        }
    }, [isShow])

    function handleCheck() {
        setCheck(!check)
        if (check) {
            remove(showcase.id)
        } else {
            add(showcase.id)
        }
    }

    return (
        <div className="flex flex-row">
            <div className='flex cursor-pointer items-center gap-2 backGroundColor p-2 rounded-lg' onClick={handleCheck}>
                {/* <label class="container-check"> */}
                <input type="checkbox" className="cursor-pointer w-4 h-4 checkBoxCustom" checked={isShow?.length > 0 ? true : false} onChange={handleCheck} />
                {/* <span class="checkmark"></span> */}
                {/* </label> */}
                <div className='text-sm blackColor'>
                    {showcase.name}
                </div>
            </div>
        </div>
    )
}

export default ShowcaseOption